export default "__VITE_ASSET__DBJMz0u8__"